import styled from "styled-components";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { Box } from "@mui/material";

export const IconGroup = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-right: 1rem;
`;

export const TreeViewContainer = styled(TreeView)`
  overflow-x: auto;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.grayPale};
  }

  .MuiTreeItem-content {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  .MuiTreeItem-label {
    width: unset !important;
  }

  .MuiTypography-root {
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  .active {
    color: ${({ theme }) => theme.colors.greenLight};
  }

  .MuiCollapse-root .MuiTreeItem-label {
    width: 100% !important;
  }

  .MuiTreeItem-iconContainer svg {
    font-size: 2.4rem !important;
  }

  /* Folhas nao tem seta, e o container vazio deixaria um recuo solto. Só que
     desde os subgrupos (Solar / Eólico) nem todo nó aninhado é folha: esconder
     o container inteiro tirava a seta deles e tornava impossível expandir.
     O seletor :empty casa apenas o container sem ícone dentro, ou seja,
     exatamente as folhas. */
  .MuiCollapse-root .MuiTreeItem-iconContainer:empty {
    display: none !important;
  }
`;
